class CustomFooter extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
            <footer class="site-footer">
      <div class="footer-container">
        <p class="copyright-text" data-i18n="foot_copyright">
          &copy; 2026 ChatMurcianys. All rights reserved.
        </p>

        <!-- Social Media Icons using Font Awesome -->
        <div class="footer-socials">
          <a
            href="https://www.facebook.com/profile.php?id=100048617843429"
            class="social-icon-link"
            aria-label="Facebook"
          >
            <i class="fa-brands fa-facebook-f"></i>
          </a>
          <a
            href="https://www.instagram.com/chatmurcianys/"
            class="social-icon-link"
            aria-label="Instagram"
          >
            <i class="fa-brands fa-instagram"></i>
          </a>
          <a
            href="https://x.com/ChatMurcianys"
            class="social-icon-link"
            aria-label="Twitter"
          >
            <i class="fa-brands fa-x-twitter"></i>
          </a>
        </div>
      </div>
    </footer>
        `;
  }
}

// Register the custom elements
customElements.define("custom-footer", CustomFooter);
